import styled from '@emotion/styled';

export const ContractDetailsContainer = styled.div`
  width: 100%;
  height: 100%;
`;
